'use client';

import { Suspense, useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import Script from 'next/script';

function YandexMetrikaInner({ ymId }: { ymId: string }) {
  const pathName = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const searchParamsString = searchParams.toString();
    const url = pathName + (searchParamsString ? '?' + searchParamsString : '');
    // @ts-ignore: ym is a global variable
    window.ym(ymId, 'hit', url);
  }, [pathName, searchParams, ymId]);

  return (
    <Script id="yandex-metrika">
      {`
        (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();
        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
        (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

        ym(${ymId}, "init", {
				     defer: true,
             clickmap:true,
             trackLinks:true,
             accurateTrackBounce:true,
             webvisor:true
        });    
      `}
    </Script>
  );
}

export default function YandexMetrika(props: { ymId: string }) {
  return (
    <Suspense fallback={null}>
      <YandexMetrikaInner {...props} />
    </Suspense>
  );
}
